import * as z from "zod";

const SyncProductsAsVariantsOutputSchema = z.discriminatedUnion("success", [
  z.object({ success: z.literal(true) }),
  z.object({ success: z.literal(false), error: z.string() }),
]);
export type SyncProductsAsVariantsOutput = z.infer<
  typeof SyncProductsAsVariantsOutputSchema
>;

export const syncProductsAsVariants = {
  name: "syncProductsAsVariants" as const,
  input: z.object({}),
  output: SyncProductsAsVariantsOutputSchema,
};
